import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { GenericDialogComponent } from 'src/app/ui/components/generic-dialog/generic-dialog.component';
import { GenericDialogDto } from '../models/dto/generic-dialog.dto';

export const genericDialog = (
  dialog: MatDialog,
  dialogInfo: GenericDialogDto,
  panelClassStyle: string
): Observable<boolean> => {
  return dialog
    .open(GenericDialogComponent, {
      data: dialogInfo,
      panelClass: [panelClassStyle],
      disableClose: true,
    })
    .afterClosed();
};
